import { createRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'infra-creator',
});

export const resourceRouteRef = createRouteRef({
  id: 'resource',
});

export const cloudSqlRouteRef = createRouteRef({
  id: 'cloudsql',
});

export const redisRouteRef = createRouteRef({
  id: 'redis',
});
